module.exports = require("./kn-IN.js");